import React, { useState, useEffect } from "react";
import { Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Chip, Typography, Box } from "@mui/material";
import Button from "../../../components/Button";
import { useNavigate } from "react-router-dom";
import "./style.css";
import axios from "axios";

export default function CancelledAndRescheduledJobs() {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCancelledAndRescheduledJobs = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          navigate("/login");
          return;
        }
        const response = await axios.get(
          " https://jobmanagement-497524552274.us-central1.run.app/api/jobs/status/cancelled-and-rescheduled",
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setJobs(response.data);
      } catch (err) {
        setError("Failed to fetch jobs. Please try again.");
      } finally {
        setLoading(false);
      }
    };
    fetchCancelledAndRescheduledJobs();
  }, [navigate]);

  // Function to format the date and time
  const formatDateTime = (dateTimeString) => {
    if (!dateTimeString) return "N/A";
    const date = new Date(dateTimeString);
    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  // Function to get status color
  const getStatusColor = (status) => {
    switch (status) {
      case 'CANCELLED':
        return '#ffebee';
      case 'RESCHEDULED':
        return '#fff8e1';
      default:
        return '#e3f2fd';
    }
  };

  // Function to get text color based on status
  const getStatusTextColor = (status) => {
    switch (status) {
      case 'CANCELLED':
        return '#c62828';
      case 'RESCHEDULED':
        return '#ff8f00';
      default:
        return '#1976d2';
    }
  };

  // Function to handle view details (if needed)
  const handleViewDetails = (jobId) => {
    navigate(`/job-details/${jobId}`);
  };

  return (
    <Grid container>
      <Grid item xs={12} sx={{ p: 3, backgroundColor: "#f5f5f5" }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Cancelled and Rescheduled Jobs
        </Typography>

        {loading ? (
          <Box sx={{ p: 3, textAlign: "center" }}>
            <Typography>Loading jobs...</Typography>
          </Box>
        ) : error ? (
          <Box sx={{ p: 3, textAlign: "center", color: "error.main" }}>
            <Typography>{error}</Typography>
          </Box>
        ) : (
          <TableContainer component={Paper} sx={{ mt: 2, mb: 2 }}>
            <Table sx={{ minWidth: 650 }} aria-label="jobs table">
              <TableHead>
                <TableRow sx={{ backgroundColor: "#f0f0f0" }}>
                  <TableCell sx={{ fontWeight: "bold" }}>Job ID</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Title</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Description</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Scheduled Time</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Status</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {jobs.length > 0 ? (
                  jobs.map((job) => (
                    <TableRow
                      key={job.jobId || job.id}
                      sx={{ '&:hover': { backgroundColor: '#f9f9f9' } }}
                    >
                      <TableCell sx={{ fontWeight: "medium" }}>
                        {job.jobId || job.id}
                      </TableCell>
                      <TableCell>{job.title || "N/A"}</TableCell>
                      <TableCell>{job.description || "N/A"}</TableCell>
                      <TableCell>{formatDateTime(job.scheduledTime)}</TableCell>
                      <TableCell>
                        <Chip
                          label={job.status || "N/A"}
                          size="small"
                          sx={{
                            backgroundColor: getStatusColor(job.status),
                            color: getStatusTextColor(job.status),
                            fontWeight: "medium"
                          }}
                        />
                      </TableCell>
                      <TableCell>
                        <button
                          onClick={() => handleViewDetails(job.jobId || job.id)}
                          style={{
                            background: "#1976d2",
                            color: "white",
                            border: "none",
                            padding: "6px 16px",
                            borderRadius: "4px",
                            cursor: "pointer",
                            fontSize: "14px"
                          }}
                        >
                          View Details
                        </button>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      <Typography sx={{ py: 2 }}>
                        No canceled or rescheduled jobs found.
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Grid>
      
      <Grid
        item
        xs={12}
        display="flex"
        justifyContent="space-between"
        bgcolor="#ffffff"
        padding="12px 20px"
        width="100%"
        style={{ position: "sticky", bottom: "0", boxShadow: "0px -2px 4px rgba(0,0,0,0.1)" }}
      >
        <Button
          name="Back to Jobs List"
          onClick={() => navigate("/jobs")}
        />
      </Grid>
    </Grid>
  );
}